import { render } from "./SelectCurrency.vue?vue&type=template&id=972b269a"
import script from "./SelectCurrency.vue?vue&type=script&lang=js"
export * from "./SelectCurrency.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__